import {
  Notification,
  INotificationProps,
  TTranslator,
} from '@smartshell/ui-kit';
import { Store } from 'react-notifications-component';

import { TLocalesKeys } from 'localization';

export interface IInfoProps extends INotificationProps {
  t: TTranslator<TLocalesKeys>;
  dismiss?: number;
}

let ids: Array<string> = [];

const params = {
  insert: 'top',
  container: 'bottom-right',
  animationIn: ['animate__animated', 'animate__fadeIn'],
  animationOut: ['animate__animated', 'animate__fadeOut'],
  width: 350,
};

const removeAll = (): void => {
  Store.removeAllNotifications();
  ids = [];
};

const notification = {
  info: ({ dismiss = 3, t, ...props }: IInfoProps): void => {
    if (ids.length === 0) {
      // @ts-ignore Incorrect library types
      const closeId = Store.addNotification({
        content: (
          <Notification
            type="close"
            handleCloseClick={removeAll}
            closeText={t('notifications.closeAll')}
          />
        ),
        ...params,
        onRemoval: (id) => {
          ids = ids.filter((x) => x !== id);
        },
      });
      ids.push(closeId);
    }

    // @ts-ignore Incorrect library types
    const notifId = Store.addNotification({
      content: <Notification {...props} />,
      ...params,
      onRemoval: (id) => {
        ids = ids.filter((x) => x !== id);
        if (ids.length <= 2) {
          removeAll();
        }
      },
    });
    ids.push(notifId);

    if (dismiss) {
      setTimeout(() => {
        Store.removeNotification(notifId);
      }, dismiss * 1000);
    }
  },

  removeAll,
};

export default notification;
